import { ControlPropertyType } from '../../../enums';

export const TimePickerProperty = {
  ...ControlPropertyType,
  FillType: 'fillType',
  Format: 'format',
  MinuteRange: 'minuteRange',
  HourRange: 'hourRange',
  MinuteInterval: 'minuteInterval',
  HourInterval: 'hourInterval',
  MinuteLabel: 'minuteLabel',
  HourLabel: 'hourLabel',
  APMLabel: 'apmLabel',
};

export default {
  TimePickerProperty,
};
